import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState, Option } from '@mews-commander/types';
import { getSourceOptions } from '@mews-commander/legacy-entities/src/ducks/sources';
import { SelectField } from '@mews-commander/legacy-form';

interface StateProps {
    options: Array<Option>;
}

export const SourceSelectField = connect<StateProps, {}, {}, ApplicationState>(
    createStructuredSelector({
        options: getSourceOptions,
    })
)(SelectField);
